import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {AuthStateService} from "../services/auth-state.service";
import {filter, map, take} from "rxjs/operators";

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authStateService = inject(AuthStateService);

  const token = localStorage.getItem("accessToken");

  if (!token) {
    return router.createUrlTree(['/login']);
  }

  return authStateService.user$.pipe(
    filter(user => user !== null),
    take(1),
    map(user => {
      if (!user) {
        return router.createUrlTree(['/login']);
      }

      if (user.isPasswordTemporary) {
        return router.createUrlTree(['/change-temporary-password']);
      }

      return true;
    })
  );
};
